<bci-wk-modal class="modal">
  <div class="container-modal">
    <img
      class="war wk-padding-bottom-24"
      src="./assets/images/icon-config-error.png"
      alt="waricon"
    />
    <div class="title wk-padding-top-8">
      <bci-wk-modal-title bciWkTypeH600
        >El servicio no está disponible en este momento</bci-wk-modal-title
      >
    </div>
    <div class="subtitle">
      <p>
        Este servicio está presentando fallas técnicas. Por favor, inténtalo más
        tarde.
      </p>
    </div>
    <bci-wk-modal-actions>
      <button bciWkButtonPrimary (click)="close()">Entendido</button>
    </bci-wk-modal-actions>
  </div>
</bci-wk-modal>
